<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-65">
      <sensor-autocomplete
        id="sensores"
        v-model="sensorId"
        name="sensores"
        :local-id="localId"
        :required="true"
      />
    </div>
    <div class="md-layout-item md-size-15">
      <md-field>
        <label for="comparador">Comparador</label>
        <md-select
          id="comparador"
          v-model="comparador"
          name="comparador"
          @md-selected="change"
        >
          <md-option v-for="comp in comparadores" :key="comp" :value="comp">
            {{ comp }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-10">
      <md-field>
        <label>Valor</label>
        <md-input
          v-model="valorBase"
          :required="true"
          type="number"
          @input="change"
        />
      </md-field>
    </div>
    <div class="md-layout-item md-size-10">
      <md-field>
        <label>Nº</label>
        <md-input
          v-model="value"
          :required="true"
          type="number"
          @input="change"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'

export default {
  name: 'TermoComparaUltimosDados',
  components: { SensorAutocomplete },
  props: {
    localId: {
      type: String,
      required: true,
    },
    initialSensorId: {
      type: String,
      default: null,
    },
    initialComparador: {
      type: String,
      default: null,
    },
    initialValueBase: {
      type: Number,
      default: null,
    },
    initialValue: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    comparadores: ['>', '>=', '==', '<', '<='],
    sensorId: null,
    comparador: '>',
    valorBase: 0,
    value: 1,
  }),
  watch: {
    sensorId() {
      this.change()
    },
  },
  beforeMount() {
    if (this.initialSensorId) {
      this.sensorId = this.initialSensorId
    }
    if (this.initialComparador) {
      this.comparador = this.initialComparador
    }
    if (this.initialValueBase) {
      this.valorBase = this.initialValueBase
    }
    if (this.initialValue) {
      this.value = this.initialValue
    }
  },
  methods: {
    change() {
      this.$emit('change', {
        sensorId: this.sensorId,
        comparador: this.comparador,
        valor: this.valorBase,
        quantidadeDadosAnteriores: this.value,
      })
    },
  },
}
</script>

<style scoped></style>
